<div [class]="calloutClass">
  <svg-icon [name]="type"></svg-icon>
  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
